import {HttpModelConverter} from '../../../../../core/converter/httpModel.converter';
import {ProviderServiceSummaryModel} from '../providerServiceSummary.model';
import {Injectable} from '@angular/core';
import {ProviderSummaryConverter} from '../../../../common/api/entity/converter/providerSummary.converter';
import {LovValueSummaryConverter} from '../../../../../common/lov/lov-value/api/converter/LovValueSummary.converter';

@Injectable({
    providedIn: 'root'
})
export class ProviderServiceSummaryConverter extends HttpModelConverter<ProviderServiceSummaryModel> {

    constructor(private providerConverter: ProviderSummaryConverter,
                private lovValueSummaryConverter: LovValueSummaryConverter) {
        super();
    }
    protected createInstance(): ProviderServiceSummaryModel {
        return new ProviderServiceSummaryModel();
    }

    protected enrichObject(result: ProviderServiceSummaryModel, src: ProviderServiceSummaryModel) {
        result.provider = this.providerConverter.convert(src.provider);
        result.service = this.lovValueSummaryConverter.convert(src.service);
    }
}
